module.exports = __webpack_public_path__ + "img/exam-miniimage-preview.21d7823a.png";